export default "__VITE_ASSET__CLZYeVQE__"